import { render } from "./SubsidiariesATF.vue?vue&type=template&id=58eed4aa&scoped=true"
import script from "./SubsidiariesATF.vue?vue&type=script&lang=js"
export * from "./SubsidiariesATF.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eed4aa"]])

export default __exports__